var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_469_58595",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 27,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.015625,
    y: 0.667969,
    width: 26.6667,
    height: 26.6667,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_469_58595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.80543 22.3346C4.24417 22.3346 3.7691 22.1401 3.38021 21.7512C2.99132 21.3624 2.79688 20.8873 2.79688 20.326V7.67653C2.79688 7.11527 2.99132 6.64019 3.38021 6.2513C3.7691 5.86241 4.24417 5.66797 4.80543 5.66797H21.8994C22.4606 5.66797 22.9357 5.86241 23.3246 6.2513C23.7135 6.64019 23.9079 7.11527 23.9079 7.67653V20.326C23.9079 20.8873 23.7135 21.3624 23.3246 21.7512C22.9357 22.1401 22.4606 22.3346 21.8994 22.3346H4.80543ZM13.3524 14.4371C13.445 14.4371 13.5369 14.4232 13.628 14.3955C13.7192 14.3677 13.8075 14.3296 13.893 14.2812L21.8396 9.19353C21.9664 9.11519 22.0561 9.0137 22.1088 8.88905C22.1615 8.76441 22.1772 8.633 22.1558 8.49483C22.1416 8.23842 22.0162 8.04791 21.7798 7.92328C21.5433 7.79863 21.3047 7.80966 21.064 7.95639L13.3524 12.8902L5.64085 7.95639C5.40011 7.80966 5.16329 7.79791 4.9304 7.92114C4.6975 8.04434 4.57036 8.23201 4.54899 8.48414C4.52762 8.63371 4.54328 8.7726 4.59599 8.9008C4.64869 9.02901 4.73843 9.12658 4.86521 9.19353L12.8118 14.2812C12.8973 14.3296 12.9856 14.3677 13.0768 14.3955C13.1679 14.4232 13.2598 14.4371 13.3524 14.4371Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailAccount);
export default __webpack_public_path__ + "static/media/mailAccount.d7dff34065a5ae715ddc29ee24450583.svg";
export { ForwardRef as ReactComponent };